<template>
  <div
    class="chat"
    v-show="customer"
  >
    <div class="removeHome">
      <div
        class="t-suspend-button"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
        ref="remove"
        :style="`left: ${oLeft}px; top: ${oTop}px;`"
      >
        <div
          class="yuanqiu"
          @click="openChat"
        >
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/pageFixed.gif" />
        </div>
        <div
          class="close"
          @click="customer = false"
        >
          <img
            src="@/assets/img/loginImg/close.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setBaseUrl } from '@/utils/tools';
export default {
  name: '',
  data() {
    return {
      isAPP: this.$root.$data.isApp,
      show: false,
      oLeft: '',
      oTop: '',
      $vm: null, // 悬浮按钮
      moving: false, // 移动状态
      oW: null, // 悬钮距离
      oH: null,
      htmlWidth: null, // 页面宽度
      htmlHeight: null,
      bWidth: null, // 悬钮宽度
      bHeight: null,
      click: false, // 是否是点击
      customer: true,
    };
  },
  props: {
    productId: {
      type: Number,
    },
    productSkuId: {
      type: Number,
    },
  },
  methods: {
    // 移动触发
    onTouchStart(event) {
      const e = event.touches[0];
      this.click = true;
      const { left, top } = this.$refs?.remove?.getBoundingClientRect();
      const { clientWidth, clientHeight } = document.documentElement;
      const { offsetWidth, offsetHeight } = this.$refs.remove;
      this.oW = e.clientX - left;
      this.oH = e.clientY - top;
      this.htmlWidth = clientWidth;
      this.htmlHeight = clientHeight;
      this.bWidth = offsetWidth;
      this.bHeight = offsetHeight;
      const oLeft = e.clientX - this.oW;
      const oTop = e.clientY - this.oH;
      this.oLeft = oLeft;
      this.oTop = oTop;
      this.moving = true;
    },
    // 移动结束
    onTouchEnd() {
      this.moving = false;
      // eslint-disable-next-line no-unused-expressions
      `${this.$refs.remove.class} t-suspend-button-animate`;
      // 左侧距离
      let { oLeft } = this;
      if (oLeft < (this.htmlWidth - this.bWidth) / 2) {
        oLeft = 0;
      } else {
        oLeft = this.htmlWidth - this.bWidth;
      }
      this.oLeft = oLeft;
    },
    // 开始移动
    onTouchMove(e) {
      this.$refs.remove.class = 't-suspend-button';
      // eslint-disable-next-line no-unused-expressions
      this.moving && this.onMove(e);
    },
    // 移动中
    onMove(event) {
      const e = event.touches[0];
      this.click = false;
      // 左侧距离
      let oLeft = e.clientX - this.oW;
      let oTop = e.clientY - this.oH;
      if (oLeft < 0) {
        oLeft = 0;
      } else if (oLeft > this.htmlWidth - this.bWidth) {
        oLeft = this.htmlWidth - this.bWidth;
      }
      if (oTop < 0) {
        oTop = 0;
      } else if (oTop > this.htmlHeight - this.bHeight) {
        oTop = this.htmlHeight - this.bHeight;
      }
      this.oLeft = oLeft;
      this.oTop = oTop;
    },
    openChat() {
      window.location.href=`${setBaseUrl('')}/iform/index/69`
      // this.$router.push({
      //   path: '/pullnew/chatCommunityPage',
      //   query: {
      //     productId: this.productId,
      //     skuId: this.productSkuId,
      //   },
      // });
    },
    closeAdvisory() {
      this.show = false;
    },
  },
  mounted() {
    this.$refs.remove.addEventListener(
      'touchmove',
      (e) => {
        if (e.cancelable) {
          e.preventDefault();
        }
      },
      { passive: false },
    );
  },
};
</script>

<style lang="scss" scoped>
.chat {
  position: fixed;
  right: 70px;
  bottom: 200px;
  z-index: 100;
  width: 140px;
  height: 140px;
  // background: #fff;
  border-radius: 10px;
  img {
    width: 140px;
    height: 140px;
  }
}

.removeHome {
  position: relative;
  .close {
    position: absolute;
    top: -20px;
    right: -5px;
    > img {
      width: 40px;
      height: 40px;
    }
  }
  .t-suspend-button {
    position: fixed;
    right: 15px;
    top: 660px;
    z-index: 999;
    width: 140px;
    height: 140px;
  }
  .t-suspend-button-animate {
    transition-duration: 0.4s;
  }
  .yuanqiu {
    width: 140px;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.chatCommunity{
  width: 500px;
  height: 300px;
}
</style>
